import { useCallback, useRef } from 'react';
import type { NativeScrollEvent, NativeSyntheticEvent } from 'react-native';
import type { ListRef } from '@banhala/ui-kit';
import { useSharedValue } from 'react-native-reanimated';

export function useScrollToTop<T>() {
  const listRef = useRef<ListRef<T>>(null);
  const scrollY = useSharedValue(0);

  const handleScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      scrollY.value = event.nativeEvent.contentOffset.y;
    },
    [scrollY],
  );

  const handleScrollToTop = useCallback(() => {
    listRef.current?.scrollToOffset({ offset: 0, animated: true });
  }, []);

  return { listRef, scrollY, handleScroll, handleScrollToTop };
}
